import { useMainStore } from '@/store/index'

// 每一行可以展示的卡片个数
type RowCardCount = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
// eslint-disable-next-line @typescript-eslint/no-explicit-any
abstract class CardListOneConfigBase<Arg extends any[] = any[]> {
  /** 初始化构造函数 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(...params: Arg) {
    const { isWeb } = useMainStore()
    if (isWeb) {
      this.initPC(...params)
    } else {
      this.initH5(...params)
    }
  }
  /** 盒子的宽度 数字:同于设计图上的px  字符串,不改变直接使用 */
  width?: number | string
  /** 每一行可以展示的卡片个数,如果不传入数量的话,则每一行,能放几个就放几个,放不下了就换行. */
  rowCardCount?: RowCardCount
  /** 卡片之间的左右间距 重点:该属性单独使用不生效,必须要设置【rowCardCount】它才有效*/
  leftRightSpacing?: number | string
  /** 卡片之间的上下间距 数字:同于设计图上的px 字符串,不改变直接使用  */
  topBotSpacing?: number | string
  /**卡片是否自动换行 true：stake版式横向排列并带滚动、拖拽、翻页， false:主流换行排列 */
  isNoWrap?: boolean
  /** 是否显示为空(优先级高于slots默认插槽,只要为true,就显示空标签) */
  isEmpty?: boolean
  /** 初始化PC */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected abstract initPC(...params: Arg): this
  /** 初始化H5 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected abstract initH5(...params: Arg): this
}
/** 从接口或类中取值,只要属性,不要方法 */
type GetKeyVal<T> = {
  [P in keyof T]: T[P]
}
/** 列表的props配置 */
type CardListOneProps = GetKeyVal<CardListOneConfigBase>

export default {
  CardListOneConfigBase
}
// 将该类型导出私有化
export type {
  RowCardCount as _RowCardCount,
  CardListOneProps as _CardListOneProps
}
